import { LayoutProps } from './MainLayout';

export default function NoopLayout({ children }: LayoutProps) {
  return (
    <>
      <div
        className="d-flex flex-column"
        style={{
          minHeight: '100vh',
          height: 'auto',
        }}
        id="App"
      >
        <div className="flex-grow-1">{children}</div>
      </div>
    </>
  );
}
